import { useEffect, useState } from "react";
import axios from "axios";
import { X, Inbox, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const InquiriesModal = ({ open, onClose }) => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/inquiries`);
        setInquiries(res.data.inquiries || []);
      } catch {
        setInquiries([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
      onClick={onClose}
      data-testid="inquiries-view-dialog"
    >
      <div
        className="max-h-[80vh] w-full max-w-3xl overflow-y-auto rounded-2xl border border-slate-200 bg-white p-7"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-200 pb-4">
          <div className="flex items-center gap-3">
            <Inbox className="h-5 w-5 text-[#2E3192]" />
            <h3 className="font-display text-lg font-bold text-slate-900">
              Contact Inquiries ({inquiries.length})
            </h3>
          </div>
          <button
            onClick={onClose}
            aria-label="Close inquiries"
            data-testid="inquiries-close-button"
            className="rounded-full border border-slate-300 p-2 text-slate-500 transition-colors hover:text-slate-900"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-16">
            <Loader2 className="h-6 w-6 animate-spin text-[#2E3192]" />
          </div>
        ) : inquiries.length === 0 ? (
          <p className="py-16 text-center text-sm text-slate-500">
            No inquiries yet. Submissions from the contact form will appear here.
          </p>
        ) : (
          <div className="mt-4 space-y-3">
            {inquiries.map((q) => (
              <div
                key={q.id}
                data-testid="inquiry-list-item"
                className="rounded-xl border border-slate-200 bg-slate-50 p-5"
              >
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <p className="font-display text-sm font-bold text-slate-900">
                    {q.name} <span className="font-normal text-slate-500">· {q.company}</span>
                  </p>
                  <span className="font-mono2 text-[10px] text-slate-500">
                    {new Date(q.created_at).toLocaleString()}
                  </span>
                </div>
                <p className="mt-1 text-xs text-[#2E3192]">
                  {q.email}
                  {q.phone ? ` · ${q.phone}` : ""} · {q.region} · {q.service}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-slate-500">{q.message}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InquiriesModal;
